import {Component} from "@angular/core";
import {UserReservation} from "../../../../../../../../../server/src/base/entities/leasing/calendar/UserReservation";
import {IUserReservationService} from "../../../../../../domain/leasing/IUserReservationService";
import {SuiModalService} from 'ng2-semantic-ui';
import {Vans} from "../../../../../../../../../server/src/base/entities/leasing/Vans";
import {animate, style, transition, trigger} from "@angular/animations";
import {CurrentVan} from "../../../../../../domain/leasing/CurrentVan";
import {UserReservationEditComponent} from "./userReservationEdit";
import {IVanCalendar} from "../../../../../../domain/leasing/IVanCalendar";
import {VanCalendar} from "../../../../../../domain/leasing/VanCalendar";
import {AdminVanCalendar} from "../../../../../../domain/leasing/AdminVanCalendar";
import {UnavailabilityVanCalendar} from "../../../../../../domain/leasing/UnavailabilityVanCalendar";
import {PriceComputation} from "../../../../../../infrastructure/leasing/PriceComputation";
import {ServerError} from "../../../../../../../../../server/src/typescript-plugin/error/ServerError";

export interface IContext {
    data:string;
}

@Component({
    selector: 'admin-leasing-userReservation',
    styleUrls: ['./userReservationEdit.scss'],
    templateUrl: './userReservationEdit.html',
    animations: [
        trigger(
            'enterAnimation', [
                transition(':enter', [
                    style({opacity: 0}),
                    animate('500ms', style({opacity: 1}))
                ]),
                transition(':leave', [
                    style({opacity: 1}),
                    animate('500ms', style({opacity: 0}))
                ])
            ]
        )
    ],
})
export class UserReservationAdminEditComponent extends UserReservationEditComponent{

    private userReservation:UserReservation;

    constructor(userReservationService:IUserReservationService, public modalService:SuiModalService){
        super(userReservationService);
    }

    ngOnInit(){
        this.Initialize();
    }

    public Open(vans:Vans, currentReservation:UserReservation) {
        this.userReservation = currentReservation;
        this.SetCurrentUserReservation(currentReservation);
        this.nbVans = vans.Value().length;
        this.currentVan = new CurrentVan(vans.Value(), this.userReservation);
        this.CreateCalendar();
        this.priceComputation = new PriceComputation(this.currentVan);
        this.modalService.open(this.config);
        this.DisplayPriceBar();
    }

    public book(){
        if(this.calendarComponent.SelectedSlots().length == 0){
            this.OpenErrorPopup("Vous devez sélectionner au moins une demi-journée");
            return;
        }
        if(this.userComponent.IsValid()){
            this.UpdateUserReservation().then(() => {
                this.confirmed = true;
            }).catch(error => {
                if(error instanceof ServerError){
                    this.HandleServerError(error);
                }else{
                    console.log(error);
                }
            });
        }
    }

    public bookButtonLabel():string{
        return "Mettre à jour";
    }

    private CreateCalendar(){
        let vanCalendar:IVanCalendar = new VanCalendar(this.currentVan.Value());
        let unavailabilityCalendar:IVanCalendar = new UnavailabilityVanCalendar(vanCalendar, this.currentVan, false);
        this.calendar = new AdminVanCalendar(unavailabilityCalendar, this.userReservation, this.currentVan);
    }

    protected ResetCalendarComponent(){
        if(this.currentVan.Value().id == this.userReservation.vanId){
            this.calendarComponent.Reset(this.userReservation.Slots());
        }else{
            this.calendarComponent.Reset();
        }
    }

    private SetCurrentUserReservation(currentReservation:UserReservation){
        var that = this;
        setTimeout(() => {
            that.userComponent.SetEmail(currentReservation.email);
            that.userComponent.SetFirstname(currentReservation.firstname);
            that.userComponent.SetLastname(currentReservation.lastname);
            that.userComponent.SetPhone(currentReservation.phone);
            that.userComponent.SetComment(currentReservation.comment);

            if(this.currentVan.Value().id == currentReservation.vanId) {
                that.calendarComponent.SetSelectedSlots(currentReservation.Slots());
            }
        }, 500);
    }

    private UpdateUserReservation():Promise<void>{
        this.FillReservationWithSelectedSlots(this.userReservation);
        this.FillReservationWithUserData(this.userReservation);

        this.userReservation.vanId = this.currentVan.Value().id;
        return this.userReservationService.Update(this.userReservation);
    }
}


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/garage/leasing/presentation/userReservation/userReservationAdminEdit.ts